import * as React from "react";
import PryNavLink from "./PryNavLink";

const PryHeader = () => {
  return (
    <>
      <PryNavLink />
    </>
  );
};
export default PryHeader;
